import { Component, ElementRef, EventEmitter, forwardRef, HostListener, Input, OnInit, Output } from "@angular/core";
import { FormSelectModelDto } from "../../pages/payment-link-list/models/paylinks.model";
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from "@angular/forms";
import { Subscription } from "rxjs";

@Component({
  selector: "app-form-custom-select",
  templateUrl: "./form-custom-select.component.html",
  styleUrls: ["./form-custom-select.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormCustomSelectComponent),
      multi: true,
    },
  ],
})
export class FormCustomSelectComponent implements OnInit, ControlValueAccessor {
  @Input() itemList: FormSelectModelDto[] = [];
  @Input() errorText: string = "";
  @Input() isDisableSelect = false;
  @Input() title = "";
  @Input() positionList: string | "top" | "bottom" = "bottom";
  @Input() isSmall = false;
  @Output() onChanges: EventEmitter<FormSelectModelDto> = new EventEmitter<FormSelectModelDto>();

  isOpenSelect = false;

  selectFormControl!: FormControl;

  subs: Subscription[] = [];

  onChange = (value: any) => {};
  onTouched = (value: any) => {};

  constructor(private el: ElementRef) {}

  ngOnInit() {
    this.selectFormControl = new FormControl("");
  }

  writeValue(value: any) {
    this.selectFormControl.setValue(this.itemList.find((item) => item.value === value)?.description);
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisableSelect = isDisabled;
  }

  @HostListener("document:click", ["$event"])
  onClick(event: Event) {
    if (!this.el.nativeElement.contains(event.target)) {
      this.isOpenSelect = false;
    }
  }

  openSelect() {
    if (!this.isDisableSelect) {
      this.isOpenSelect = true;
    }
  }

  setSelectedItem(itemSelected: FormSelectModelDto) {
    this.onChange(itemSelected.value);
    this.selectFormControl.setValue(this.itemList.find((item) => item.value === itemSelected.value)?.description);
    this.isOpenSelect = false;
    this.onChanges.emit(itemSelected);
  }

  onTouchedFn(event: FocusEvent) {
    this.onChange(this.selectFormControl.value);
    this.onTouched(event);
  }
}
